import { inputAnatomy } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers } from "@chakra-ui/react";

const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(inputAnatomy.keys);

const baseStyle = definePartsStyle({
  field: {
    borderRadius: "10px",
    color: "gray.400",
    borderColor: "white",
    fontWeight: 300,
    _placeholder: {
      color: "gray.600",
      fontStyle: "italic",
    },
  },
});

const inputTheme = defineMultiStyleConfig({
  baseStyle,
  defaultProps: {
    size: "sm",
  },
});

export default inputTheme;
